import React, { Fragment } from 'react'
import WEBINAR_IMG from './chat-with-bot.svg'
import PURPLE_ARROW from './purple-arrow.svg'
import SuccessLander from 'components/SuccessLander'
import { goBack } from 'react-router-redux'
import { bindActionCreators } from "redux"
import { connect } from 'react-redux'
import './style.css'

const HEADER_TEXT = 'We’re still working on this one…'
const BUTTON_TEXT = 'Choose another bot'
const SUBHEADER_TEXT = <Fragment>…but your Customer Success Manager can help you build this bot from scratch! <br/>For now, you can try your hand at one of our other bots.</Fragment>

const OnboardingPlaybookWebinarStep = ({ actions }) => (
  <Fragment>
    <SuccessLander
    className="playbook-webinar-success-lander"
    image={WEBINAR_IMG}
    headerText={HEADER_TEXT}
    buttonText={BUTTON_TEXT}
    onButtonClick={() => actions.pop()}
    subheaderText={SUBHEADER_TEXT}/>
    <div className="playbook-webinar-tip"><img src={PURPLE_ARROW} alt="purple-arrow"/>Great choice!</div>
  </Fragment>
)

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    pop: goBack,
  }, dispatch)
})

export default connect(null, mapDispatchToProps)(OnboardingPlaybookWebinarStep)



// WEBPACK FOOTER //
// ./src/layouts/OnboardingPlaybookWebinarStep/index.js